<template>
    <div>
        <app-tabela
            :itens="requisicaoItens"
            :campos="campos"
            :itensPorPagina="itensPorPagina"
            :bordered="false"
            :small="false"
        >
            <template slot="descricao" slot-scope="data">
                {{ data.descricao }} ({{ data.idItemContrato }})
            </template>
            <template slot="valorUnitario" slot-scope="data">{{
                data.valorUnitario | currency
            }}</template>
            <template slot="quantidade" slot-scope="data">{{
                data.quantidade | currency2
            }}</template>
            <template slot="subTotal" slot-scope="data">{{
                data.subTotal | currency
            }}</template>
            <template slot="desconto" slot-scope="data"
                >{{ data.desconto | currency
                }}<btn-justificativa-desconto
                    :itemRequisicao="data"
                ></btn-justificativa-desconto
            ></template>
            <template slot="valorTotal" slot-scope="data">{{
                data.valorTotal | currency
            }}</template>
        </app-tabela>
    </div>
</template>

<script>
import BtnJustificativaDesconto from './BtnJustificativaDesconto'

export default {
    props: {
        requisicao: {
            type: Object,
            default: () => {}
        },

        dataServico: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            requisicaoItens: [],
            campos: [
                {
                    key: 'descricao',
                    label: 'Item do Contrato',
                    filterable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor Unitário',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'subTotal',
                    label: 'SubTotal',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'desconto',
                    label: 'Desconto',
                    tdClass: 'text-nowrap text-right'
                },
                {
                    key: 'valorTotal',
                    label: 'Valor Total',
                    tdClass: 'text-nowrap text-right'
                }
            ],
            itensPorPagina: 5
        }
    },

    mounted() {
        this.requisicaoItens = [...this.requisicao.itens]
    },

    watch: {
        requisicao() {
            this.requisicaoItens = [...this.requisicao.itens]
        }
    },

    components: {
        BtnJustificativaDesconto
    }
}
</script>
